module.exports = __webpack_public_path__ + "static/media/ic_play.eb3b393f.svg";